import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
/** BiData that does not allow contextual data, use this outside of components */ export function PureBiData(data) {
    return _object_spread_props(_object_spread({}, data), {
        _biLoggerVersion: 2
    });
}

//# sourceMappingURL=base.js.map